export class ResultData {
    result: number;
    data: object;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/resultData.ts